import { LoggedInConfluenceBlueWaveTemplate } from '../../components/logged-in-confluence-blue-wave-template';

import { useIntl } from 'react-intl';

export const LoggedInConfluenceStandard = () => {
	const { formatMessage } = useIntl();
	return (
		<LoggedInConfluenceBlueWaveTemplate
			productEditionText={formatMessage({
				id: 'WacSignupHeader.cloudStandard',
				defaultMessage: 'Cloud Standard',
			})}
		/>
	);
};
